import React, { PureComponent } from 'react';
import { Field, reduxForm } from 'redux-form';
import { Icon, CardActions, CardContent } from '@material-ui/core';
import Button from 'components/base/Button';
import { connect } from 'react-redux';
import withAll from 'components/base/withAll';
import Input from 'components/base/forms/Input';
import PropTypes from 'prop-types';
import {
  companyEmailValidator,
  passwordValidator,
  passwordsMatch,
  phoneValidator,
  emailValidator,
} from 'utils/validators';
import Error from 'components/base/forms/Error/index';
import TermsAgreement from 'components/common/TermsAgreement';
import { combine, required, validateForm, length } from 'redux-form-validators';
import { forms } from 'constants/config';

const customValidate = {
  firstName: combine(
    required({ msg: 'First name is required.' }),
    length({ max: 100, msg: 'Value exceeds 100 characters' }),
  ),
  lastName: combine(
    required({ msg: 'Last name is required.' }),
    length({ max: 100, msg: 'Value exceeds 100 characters' }),
  ),
  company: combine(
    required({ msg: 'Company is required.' }),
    length({ max: 100, msg: 'Value exceeds 100 characters' }),
  ),
  password: combine(
    required({ msg: 'Password is required.' }),
    passwordValidator,
  ),
  confirmPassword: combine(
    passwordsMatch('Password does not match.'),
    required({ msg: 'Password confirmation is required.' }),
  ),
};

class BetaSignup extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    error: PropTypes.string,
    phoneNumbersEnabled: PropTypes.bool,
    corporateEmailEnabled: PropTypes.bool,
  };

  static defaultProps = {
    error: null,
    phoneNumbersEnabled: true,
    corporateEmailEnabled: true,
  };
  render() {
    const {
      handleSubmit, error, phoneNumbersEnabled, corporateEmailEnabled,
    } = this.props;
    const phoneNumberRequired = value => (
      (!value && phoneNumbersEnabled) ? (
        combine(
          required({ msg: 'Phone is required.' }),
          phoneValidator,
        )) :
        combine(phoneValidator));
    const emailRequired = () => (
      (corporateEmailEnabled) ? (
        combine(
          required({ msg: 'Corporate Email is required.' }),
          companyEmailValidator,
        )) :
        combine(
          required({ msg: 'Email is required.' }),
          emailValidator,
        ));
    return (
      <form className="form" onSubmit={handleSubmit}>
        <CardContent>
          <div>
            <Field
              name="firstName"
              component={Input}
              type="text"
              placeholder="First Name"
              label="First Name"
              fullWidth
            />
          </div>
          <div>
            <Field
              name="lastName"
              component={Input}
              type="text"
              placeholder="Last Name"
              label="Last Name"
              fullWidth
            />
          </div>
          <div>
            <Field
              name="email"
              component={Input}
              type="text"
              placeholder="Corporate Email"
              label="Corporate Email"
              validate={emailRequired()}
              fullWidth
            />
          </div>
          <div>
            <Field
              name="phoneNumber"
              component={Input}
              type="text"
              placeholder="Phone"
              label="Phone"
              validate={phoneNumberRequired()}
              fullWidth
            />
          </div>
          <div>
            <Field
              name="company"
              component={Input}
              type="text"
              placeholder="Company"
              label="Company"
              fullWidth
            />
          </div>
          <div>
            <Field
              name="password"
              component={Input}
              type="password"
              placeholder="Password"
              label="Password"
              fullWidth
            />
          </div>
          <div>
            <Field
              name="confirmPassword"
              component={Input}
              type="password"
              placeholder="Confirm password"
              label="Confirm password"
              fullWidth
            />
          </div>
          <div>
            <TermsAgreement />
          </div>
          <div>
            <Error error={error} />
          </div>
        </CardContent>
        <CardActions>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            type="submit"
            id="signUpFormBtn"
          >
            <Icon>send</Icon> Sign up
          </Button>
        </CardActions>
      </form>
    );
  }
}
const mapStateToProps = state =>
  ({
    corporateEmailEnabled: state.configs.data.corporateEmailEnabled,
    phoneNumbersEnabled: state.configs.data.phoneNumbersEnabled,
  });


export default withAll(
  connect(mapStateToProps, null),
  reduxForm({ form: forms.BETA_SIGNUP_FORM, validate: validateForm(customValidate) }),
)(BetaSignup);
